
/* IMPORTAÇÕES */

import Template from './components/Template.js';
import BannerHome from './components/BannerHome.js';
import NavegacaoInterna from './components/NavegacaoInterna.js';
import EducacaoAntirracista from './components/EducacaoAntirracista.js';
import NossasAcoes from './components/NossasAcoes.js';
import Publicacoes from './components/Publicacoes.js';
import SugestaoConteudo from './components/SugestaoConteudo.js';
import NossasRedes from './components/NossasRedes.js';
import FacetsController from './components/FacetsController.js';

/* INSTANCIA CLASSES */

const template = new Template;
const bannerhome = new BannerHome;
const navegacaointerna = new NavegacaoInterna;
const educacaoantirracista = new EducacaoAntirracista;
const nossasacoes = new NossasAcoes;
const publicacoes = new Publicacoes;
const sugestaoconteudo = new SugestaoConteudo;
const nossasredes = new NossasRedes;
const facetscontroller = new FacetsController;

/* RUN EVENTOS HABILITANDO JQUERY */

$(function()
{
    template.init();
    bannerhome.init();
    navegacaointerna.init();
    educacaoantirracista.init();
    nossasacoes.init();
    publicacoes.init();
    sugestaoconteudo.init();
    nossasredes.init();
        
    window.onload = function()
    {   
        facetscontroller.init();

        $('.ShowOnLoad').each(function()
        {
            $(this).stop().animate({opacity:1},400);
        })
    }();
});